import React from "react";
import styled from "styled-components";

const StyledCancerSelector = styled.button`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.1;
`;
export function HeaderCancerSelection({
  children,
  className,
  onClick,
  ...props
}) {
  return (
    <StyledCancerSelector
      data-design-category="top_nav_vd"
      className={className}
      onClick={onClick}
      {...props}
    >
      {children}
    </StyledCancerSelector>
  );
}
